import { ExpertStoreInterface } from '../models/expert-store.interface';

export const initialExpertState: ExpertStoreInterface = {
  name: '',
  isTyping: false,
  img: '',
};
